import * as React from "react";

import { Button } from "@common/components/Button";

import "./color-picker.styles.scss";

export type ColorPickerProps = {
  onChange: (color: string) => void;
  value?: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  buttonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
};

export const ColorPicker: React.FC<ColorPickerProps> = ({ onChange, inputProps, buttonProps, value }) => {
  const colorPickerInputRef = React.useRef<HTMLInputElement>(null);

  return (
    <>
      <input
        {...inputProps}
        type="color"
        style={{ width: 0, height: 0, opacity: 0 }}
        ref={colorPickerInputRef}
        onChange={(e) => onChange(e.target.value)}
        value={value}
      />
      <Button
        {...buttonProps}
        style={{ textOverflow: "unset" }}
        onClick={() => {
          colorPickerInputRef?.current?.click();
        }}
      >
        <img src="png/color-picker.png" style={{ width: "15px", height: "15px" }} />
      </Button>
    </>
  );
};
